import React, { useState, useMemo, useEffect } from 'react';
import SortBySelect from '../../dashboard-shared/sort-by-select/sort-by-select.jsx';
import Modal from 'react-bootstrap/Modal';
import '../active-tasks-bar-graph/active-strs-bar-chart.scss';
import '../../dashboard-shared/completed-vs-overdue.scss';
import FluentUiIcon from '../../../../assets/fluent-ui-icon.jsx';
import { FluentButton } from "../../../../components/FluentUI/Fluent-Button.jsx";
import { formatLabels } from '../../dashboard-util/dashboard-utils.jsx';
import PropTypes from 'prop-types';
import LineGraph from './line-graph.jsx';

const storedSort = localStorage.getItem("ageOfCases_sort") || "Last 3 Months";

const AgeOfCasesLineGraph = ({
  data,
  fetchData,
  customStart,
  customEnd,
  setCustomStart,
  setCustomEnd,
}) => {
  const [modalShow, setModalShow] = useState(false);
  const [sort, setSort] = useState(storedSort);

   const handleSelect = (selectedValue) => {
    setSort(selectedValue);
    handleDateRange(selectedValue);
  };

  const handleDateRange = (selectedValue) => {
    let startDate = new Date();
    let endDate = new Date();
    if (selectedValue === 'Last 3 Months') {
      startDate.setDate(startDate.getDate() - 90);
    }
    else if (selectedValue === 'Last 6 Months') {
      startDate.setDate(startDate.getDate() - 180);
    }
    else if (selectedValue === 'Last 12 Months') {
      startDate.setDate(startDate.getDate() - 365);
    }

    setCustomStart(startDate);
    setCustomEnd(endDate);
    
    localStorage.setItem('ageOfCases_sort', selectedValue);
    localStorage.setItem('ageOfCases_sort_start', startDate.toISOString());
    localStorage.setItem('ageOfCases_sort_end', endDate.toISOString());
  };

  useEffect(() => {
    if (customStart && customEnd) {
      fetchData(customStart, customEnd);
    }
  }, [customStart, customEnd]);

  const renderLineGraph = useMemo(() => {
    const formattedLabels = formatLabels(data.Labels || []);
    return (
      <LineGraph
        xlabels={formattedLabels}
        label1="Incoming"
        label2="Remaining"
        dateForLabel1={data.Incoming || []}
        dateForLabel2={data.Remaining || []}
        isMagnified={false}
      />
    );
  }, [data]);

  return (
    <div className="active-strs-doughnut-chart-container">
      <div
        className="active-str-doughnut-chart-header"
        style={{ height: "42.5px" }}
      >
        <div className="active-str-doughnut-header-left">
          <h4 className="active-str-doughnut-panel-title">
            Incoming vs. Remaining STRs from &nbsp;
          </h4>
          <SortBySelect
            value={sort}
            handleSelect={handleSelect}
            options={["Last 3 Months", "Last 6 Months", "Last 12 Months"]}
            type={0}
            isMagnified={modalShow}
          />
        </div>
        <FluentButton
          appearance="none"
          onClick={() => setModalShow(true)}
          icon={
            <FluentUiIcon
              name="ArrowMaximizeRegular"
              color="#0F6CBD"
              size={20}
            />
          }
        />
      </div>
      <Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        dialogClassName="completed-vs-overdue-modal-dialog"
        contentClassName="completed-vs-overdue-modal-styles"
      >
        <Modal.Header className="p-0 w-100">
          <div className="completed-vs-overdue-modal-header-container d-flex">
            <h4
              className="active-str-doughnut-panel-title"
              style={{ marginTop: "2px" }}
            >
              Incoming vs. Remaining STRs from &nbsp;
            </h4>
            <SortBySelect
              value={sort}
              handleSelect={handleSelect}
              options={["Last 3 Months", "Last 6 Months", "Last 12 Months"]}
              type={0}
              isMagnified={modalShow}
            />
            <div className="d-flex flex-grow-1 justify-content-end align-items-center">
              <button
                className="completed-vs-overdue-exit-modal header-button"
                onClick={() => setModalShow(false)}
              ></button>
            </div>
          </div>
        </Modal.Header>
        <Modal.Body className="p-0">
          <LineGraph
            xlabels={formatLabels(data.Labels || [])}
            label1="Incoming"
            label2="Remaining"
            dateForLabel1={data.Incoming || []}
            dateForLabel2={data.Remaining || []}
            isMagnified={true}
          />
        </Modal.Body>
      </Modal>

      <div>{renderLineGraph}</div>
    </div>
  );
};

AgeOfCasesLineGraph.propTypes = {
  data: PropTypes.shape({
    Labels: PropTypes.arrayOf(PropTypes.string),
    Incoming: PropTypes.arrayOf(PropTypes.number),
    Remaining: PropTypes.arrayOf(PropTypes.number),
  }).isRequired,
  fetchData: PropTypes.func.isRequired,
  customStart: PropTypes.instanceOf(Date),
  customEnd: PropTypes.instanceOf(Date),
  setCustomStart: PropTypes.func.isRequired,
  setCustomEnd: PropTypes.func.isRequired,
};

export default AgeOfCasesLineGraph;
